<template>
    <a
        class="sidebar-ranking-card"
        target="_blank"
        :href="gotoLink(partner)"
        v-bind:aria-label="partner['provider_name']"
        rel="nofollow"
        :style="{
            '--flag-bg-color': flagBackgroundColor,
            '--flag-text-color': flagTextColor,
            '--border-color': borderColor,
        }"
    >
        <div class="card__flag" v-if="!index && partner.marketing.flag">
            {{ $t(partner.marketing.flag) }}
        </div>

        <div class="card__content">
            <div class="card__content-wrapper">
                <img
                    class="card__image"
                    v-lazy="getPartnerLogo"
                    :alt="partner.provider_name"
                />

                <div class="card__score">
                    <Rating
                        :rating="partner.rating"
                        active-color="#e11d48"
                        inactive-color="#f4f4f5"
                        active-icon="star"
                        inactive-icon="star"
                    />
                    {{ partner.rating }}
                </div>
            </div>

            <p
                class="card__description"
                v-html="
                    partner['marketing'].price || partner['marketing'].members
                "
            ></p>

            <cta-button
                class="card__button"
                :clickout-link="gotoLink(partner)"
                :fill="ctaButtonColor"
                :text-color="ctaButtonTextColor"
                :text="partner.cta_text"
                small
            >
                {{ $t('Secure Offer now!') }}
            </cta-button>
        </div>
    </a>
</template>

<script>
import { clickOutMixin } from '@/mixins';

export default {
    name: 'SidebarRankingCard',
    mixins: [clickOutMixin],
    props: {
        partner: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
        ctaButtonColor: {
            type: String,
            default: '#e11d48',
        },
        ctaButtonTextColor: {
            type: String,
            default: '#ffffff',
        },
        flagTextColor: {
            type: String,
            default: '#ffffff',
        },
        flagBackgroundColor: {
            type: String,
            default: '#e11d48',
        },
        borderColor: {
            type: String,
            default: '#e5e5e5',
        },
    },
    computed: {
        getPartnerLogo() {
            return `${this.$globalConstants.imageUrl}/${this.partner['provider_logo']}?d=120x50&q=90`;
        },
    },
    methods: {
        gotoLink(partner) {
            const link = partner['clickout_url'];

            let params = `clickin_id=${window['__clId__']}&user_token=${window['__token__']}`;

            try {
                const pageUrl = location.origin + location.pathname;
                params = `${params}&referer_url=${pageUrl}`;
            } catch (e) {
                console.log(e);
            }

            if (link && link.includes('?')) {
                return `${link}&${params}`;
            }
            return `${link}?${params}`;
        },
    },
};
</script>

<style scoped>
.sidebar-ranking-card {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid var(--border-color);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    position: relative;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.15s;

    &:hover {
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -4px rgba(0, 0, 0, 0.1);
        transform: translate(0, -0.125rem) rotate(0deg) skewX(0deg) skewY(0deg)
            scaleX(1) scaleY(1);

        .cta-button {
            filter: brightness(102%);
            opacity: 0.9;
        }
    }

    .card__flag {
        --r: 0.4em;
        --c: var(--flag-bg-color);
        font-size: 12px;
        font-weight: 600;
        color: var(--flag-text-color, #fff);
        z-index: 2;
        position: absolute;
        top: -20px;
        left: 0;
        inset-inline: calc(-1 * var(--r));
        text-align: center;
        line-height: 2;
        padding: 0 0.5em calc(2 * var(--r));
        border-radius: var(--r);
        --_g: 100% / var(--r) calc(2 * var(--r)) no-repeat;
        background: radial-gradient(100% 50% at right, #0005 98%, #0000 101%) 0
                var(--_g),
            radial-gradient(100% 50% at left, #0005 98%, #0000 101%) 100%
                var(--_g),
            conic-gradient(
                    from 90deg at var(--r) calc(100% - 2 * var(--r)),
                    #0000 25%,
                    var(--c) 0
                )
                0 0 / calc(100% - var(--r)) 100%;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .card__content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;

        .card__content-wrapper {
            display: flex;
            justify-content: space-between;
            gap: inherit;
            align-items: center;

            .card__image {
                max-height: 50px;
                object-fit: contain;
                max-width: 50%;
            }

            .card__score {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 4px;
                font-size: 20px;
                font-weight: bold;
                color: #333;
            }
        }

        .card__description {
            font-size: 13px;
            line-height: 1.25;
            font-weight: 400;
            color: #09090b;
        }

        .card__button {
            height: 36px;
        }
    }
    ::v-deep strong {
        font-weight: 400 !important;
    }
}
</style>
